import { reactive } from "vue";

/**
 * 功能板块可见性（后台可配）。
 * 板块键与 Navbar 菜单、路由 meta.section 保持一致。
 */
const DEFAULTS = {
  square: true, // AI应用广场
  workbench: true, // 我的AI工作台
  create: true, // AI创想广场
  knowledge: true, // 知识智能体
  knowledgelink: true, // 知识链接（学科知识点体系）
  agents: true, // AI智能体
  software: true, // 软件下载
};

const CACHE_KEY = "nav_visibility";

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      return { ...DEFAULTS, ...JSON.parse(raw) };
    }
  } catch (e) {
    /* ignore */
  }
  return { ...DEFAULTS };
}

const config = reactive(readCache());

export function setVisibility(data) {
  if (data) {
    Object.assign(config, data);
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  }
}

export function getVisibility() {
  return config;
}

/** 板块是否显示（未配置视为显示） */
export function isVisible(section) {
  if (!section) return true;
  return config[section] !== false;
}

/**
 * 启动时加载一次（公开接口，失败用缓存/默认值）。
 * 带缓存是为了让路由守卫能同步判断，避免首屏闪一下。
 */
export async function loadVisibility(axiosInstance) {
  try {
    const res = await axiosInstance({ url: "visibility", method: "GET" });
    if (res && res.code === 200 && res.data) {
      setVisibility(res.data);
    }
  } catch (e) {
    /* 静默失败 */
  }
  return config;
}
